var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.3335C24 16.2726 23.5786 15.2552 22.8284 14.5051C22.0783 13.7549 21.0609 13.3335 20 13.3335C18.9391 13.3335 17.9217 13.7549 17.1716 14.5051C16.4214 15.2552 16 16.2726 16 17.3335C16 22.0002 14 23.3335 14 23.3335H26C26 23.3335 24 22.0002 24 17.3335Z",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1543 26C21.0371 26.2021 20.8689 26.3698 20.6665 26.4864C20.4641 26.6029 20.2346 26.6643 20.001 26.6643C19.7674 26.6643 19.5379 26.6029 19.3355 26.4864C19.1331 26.3698 18.9649 26.2021 18.8477 26",
    stroke: "#155DFC",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellIcon);
export default __webpack_public_path__ + "static/media/notificationBellIcon.4d3aec27f4d943ccf220724bb47efd24.svg";
export { ForwardRef as ReactComponent };